const angular = require('angular');

const { sortByKeys } = require('./tile-list-sort-by-keys.constants');
const { ghostTileComponentDefinition } = require('./ghost-tile.component');
const { tileListComponentDefinition } = require('./tile-list.component');
const { tileListWithContentComponentDefinition } = require('./tile-list-with-content.component');
const { tileComponentDefinition } = require('./tile.component');
const { productFilterComponentDefinition } = require('./filter/product-filter.component');
const { stringFilterComponentDefinition } = require('./filter/string-filter.component');
const { selectedFiltersComponentDefinition } = require('./filter/selected-filters.component');
const { ProductFilterService } = require('./filter/product-filter.service');
const { zeroFilterResultsComponentDefinition } = require('./zero-filter-results.component');

angular.module('wowApp.shop')
    .constant('SortByKeys', sortByKeys)
    .service('ProductFilterService', ProductFilterService)
    .component('wowGhostTile', ghostTileComponentDefinition)
    .component('wowTileList', tileListComponentDefinition)
    .component('wowTileListWithContent', tileListWithContentComponentDefinition)
    .component('wowTile', tileComponentDefinition)
    .component('wowProductFilter', productFilterComponentDefinition)
    .component('wowStringFilter', stringFilterComponentDefinition)
    .component('wowSelectedFilters', selectedFiltersComponentDefinition)
    .component('wowZeroFilterResults', zeroFilterResultsComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/tiles/index.js